import { Select } from 'antd';
import { useState, useEffect } from 'react';

const { Option } = Select;
const CODFilterSingle = (props) => {

    const [selectedOptions, setSelectedOptions] = useState([]);

    useEffect(() => {
        setSelectedOptions(["All"]);
      }, []);

    function handleChange(value) {
        setSelectedOptions([`${value}`]);
      }

    props.onChange(selectedOptions);
    
    return ( 
        <Select defaultValue="All" style={{ width: 154, fontSize: '15px' }} dropdownMatchSelectWidth={false} onChange={handleChange}>
            <Option style = {{ color: '#70ad47', fontFamily: 'Helvetica' }} value="All">รวมทุกสาเหตุ</Option>
            <Option style = {{ color: '#70ad47', fontFamily: 'Helvetica' }} value="กลุ่มโรคติดเชื้อ, ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง">กลุ่มโรคติดเชื้อ, ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง</Option>
            <Option style = {{ color: '#70ad47', fontFamily: 'Helvetica' }} value="โรคไม่ติดต่อ">โรคไม่ติดต่อ</Option>
            <Option style = {{ color: '#70ad47', fontFamily: 'Helvetica' }} value="การบาดเจ็บ">การบาดเจ็บ</Option>
            <Option style = {{ color: '#70ad47', fontFamily: 'Helvetica' }} value="ไม่ทราบสาเหตุการตาย">ไม่ทราบสาเหตุการตาย</Option>
        </Select>
     );
}
 
export default CODFilterSingle;